<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>

    <MensagemAlerta class="row-space" v-if="errorMessage" :mensagem="errorMessage" />

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-codigo">
                <label class="label-caption">Cobrança</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.cdcobranca) }}</div>
            </div>

            <div class="form-item-data">
                <label class="label-caption">Data</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtcobranca) }}</div>
            </div>

            <div class="form-item ">
                <label class="label-caption">Nome</label>
                <div class="field-label">{{ objView.nmpessoa }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">CPF/CNPJ</label>
                <div :class="{
                    'field-label-alert': !objView.cpfcnpj,
                    'field-label': objView.cpfcnpj,
                    'field-label-center': true
                }">{{ objView.cpfcnpj }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">CEP</label>
                <div :class="{
                    'field-label-alert': !objView.cep,
                    'field-label': objView.cep,
                    'field-label-center': true
                }">{{ objView.cep }}</div>
            </div>
        </div>


        <div class="row">
            <div class="form-item-char15">
                <label class="label-caption">Valor Total</label>
                <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.vltotal) }}</div>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Recebido</label>
                <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.vlrecebido) }}</div>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">À Receber</label>
                <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.vlareceber) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Situação</label>
                <div class="field-label">{{ objView.nmsituacao }}</div>
            </div>

            <div class="row-end" v-if="!showCancelamento">
                <button @click="gerarBoleto">Gerar Boletos</button>
                <button v-if="objView.idsituacao===1" @click="showCancelamento=true">Cancelamento</button>
                <button @click="closeForm">Retornar</button>
            </div>
        </div>
    </div>

    <div v-if="showCancelamento" class="form-edit-page">
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Justificativa</label>
                <input type="text" v-model="edInfoCancelamento" maxlength="100" v-uppercase />
            </div>
        </div>
        <div class="row-end">
            <button class="btn-confirm" @click="salvarCancelamento()">Confirmar</button>
            <button @click="showCancelamento=false; errorMessage=null">Voltar</button>
        </div>
    </div>


    <div class="form-edit-page row-space">
        <div class="row-start row-space"><h3>PARCELAS</h3></div>
        <table>
            <thead><tr>
                <th class="col-width-integer">Parcela</th>
                <th class="col-width-date">Vencimento</th>
                <th class="col-width-date">Pagamento</th>
                <th class="col-width-char30">Título</th>
                <th>Situação</th>
                <th class="col-width-number">Valor</th>
                <th class="col-width-number">À Receber</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsParcelas" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-integer right">{{ obj.parcela }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtvencimento) }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtpagamento) }}</td>
                    <td class="col-width-char30">{{ obj.nrotitulo }}</td>
                    <td>{{ obj.nmsituacao }}</td>
                    <td class="col-width-number right">{{ Funcoes.formatDecimal(obj.vlparcela) }}</td>
                    <td class="col-width-number right">{{ Funcoes.formatDecimal(obj.vlareceber) }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="form-edit-page row-space">
        <div class="row-start row-space"><h3>ÍTENS DA COBRANÇA</h3></div>
        <table>
            <thead><tr>
                <th class="col-width-integer">OS</th>
                <th class="col-width-char20">Tipo</th>
                <th class="col-width-char30">Grupo</th>
                <th>Serviço</th>
                <th class="col-width-number">Vl Serviço</th>
                <th class="col-width-number">Saldo Débito</th>
                <th class="col-width-number">Saldo Crédito</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsItens" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-integer right">{{ obj.cdos }}</td>
                    <td class="col-width-char20">{{ obj.nmtipo }}</td>
                    <td class="col-width-char30">{{ obj.nmgrupo }}</td>
                    <td>{{ obj.nmservico }}</td>
                    <td class="col-width-number right">{{ Funcoes.formatDecimal(obj.vlservicos) }}</td>
                    <td class="col-width-number right">{{ Funcoes.formatDecimal(obj.vlhoras_debito) }}</td>
                    <td class="col-width-number right">{{ Funcoes.formatDecimal(obj.vlhoras_credito) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost, getCarneBoletoPdf } from '@/funcoes/api';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close','save']);
const props = defineProps({idView: {type: Number, default: 0}});

const edInfoCancelamento = ref(null);
const emitSave= ref(false);
const errorMessage = ref(null);
const isLoading = ref(false);
const lsItens = ref([]);
const lsParcelas = ref([]);
const objView = ref({});
const showCancelamento = ref(false);
        
const closeForm = () => {
    emit('close'); 
    if (emitSave.value){emit('save')}
}

const gerarBoleto = async() =>{
    try{
        isLoading.value=true;
        errorMessage.value=null;

        // REGISTRAR BOLETOS PENDENTES
        for (const parc of lsParcelas.value){
            if ((parc.nrotitulo == null) && (errorMessage.value==null)){
                const r = await genericPost('/cobranca_api/incluir', {
                    idmunicipio: globalStore.idmunicipio,
                    id: parc.id, 
                    idlogin: globalStore.idlogin,
                    idusuario: globalStore.idusuario});
                if (r.bolok==0){
                    errorMessage.value=r.erro;
                }
            }
        }

        // SE TODOS REGISTRADOS SEM ERRO ENTÃO CHAMA RELATÓRIO EM PDF
        const response = await getCarneBoletoPdf(objView.value.id);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    }catch (error){errorMessage.value=error;
    }finally{isLoading.value=false;}

}

const lerDados = async() => {
    try{
        isLoading.value = true;
        const req = await genericPost('/financeiro/cobrancas/lista', {idmunicipio: globalStore.idmunicipio, id: props.idView});
        Object.assign(objView.value, req[0]);
        if (objView.value){
            const parc = await genericPost('/financeiro/lista/parcelas', {idmunicipio: globalStore.idmunicipio, intparam2: props.idView});
            lsParcelas.value = parc;
            
            const itens = await genericPost('/financeiro/lista/itens', {id: props.idView});
            lsItens.value = itens;
        }
    }catch (error){alert(error);
    }finally{isLoading.value = false;}
}

const salvarCancelamento = async() => {
    try{
        if (!edInfoCancelamento.value) throw new Error('Informe a justificativa');
        isLoading.value=true;
        errorMessage.value=null;
        const r = await genericPost('/financeiro/cobranca/cancelamento', {
            idmunicipio: globalStore.idmunicipio,
            id: objView.value.id, 
            idlogin: globalStore.idlogin, 
            strparam1: edInfoCancelamento.value});
        if (r.bolok==1){
            lerDados();
            emitSave.value=true;
            showCancelamento.value=false;
        }else{throw new Error(r.erro);}
    }catch (error){errorMessage.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

onMounted(lerDados);
</script>